







































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Achat} from '@/models';

import CrudAchatGeneralEdit from "@/components/Crud/Achat/EditGeneral.vue";

@Component({
	components: {
		CrudAchatGeneralEdit,
	}
})
export default class CrudAchatGeneralEditDialog extends Vue {
	@InOut({ type: Achat  , isVModel: true }) private value!: Achat;

	@Emit()
	private onSubmit(achat: Achat) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		if (this.value.id) 
		{
			if (
				this.$route.name !== 'achat-show' ||
				this.$route.params["id"] !== this.value.id.toString()
			) {
				this.$router.push({name: 'achat-show', params: { id : this.value.id.toString() }});
			}
		}
		this.value = null;
	}
}
